import ButtonViewTest from "./ButtonViewTest"

function BottomGrid(props) {
	return (
		<div style={{ background: "#f5f5f5", display: "flex", alignItems: "center" }}>
			<ButtonViewTest text="Edit Position" borderRadius="0px" borderColor="#ff9170" background="white" color="#ff9170" onClick={() => props.changeEdit()} />
			<ButtonViewTest text="Set-Up Done" borderRadius="0px" borderColor="transparent" background="linear-gradient(90deg, #F7707D 0%, #F29173 100%)" color="white" onClick={() =>props.setupDone()} />
		</div>);
}

export default BottomGrid;